import { IconBarChartAxisUp, IconRefreshCcw } from '@iwoca/icons';
import { Trans } from '@lingui/react/macro';
import clsx from 'clsx';
import styles from './RCFRepaymentSchedule.module.css';

export const PostRepaymentFreePeriodExplainer = () => {
  return (
    <div className={clsx(styles.sectionHeader, styles.explainerContent)}>
      <h4 className={styles.sectionTitle}>
        <Trans>Your choice in month 12</Trans>
      </h4>
      <div className={styles.explainerPoint}>
        <IconRefreshCcw className={styles.icon} />
        <p className={styles.explainerText}>
          <Trans>
            <strong>Remain flexible:</strong> Extend the repayment-free period
            by another 12 months (subject to credit assessment).
          </Trans>
        </p>
      </div>
      <div className={styles.explainerPoint}>
        <IconBarChartAxisUp className={styles.icon} />
        <p className={styles.explainerText}>
          <Trans>
            <strong>Repay as planned:</strong> You will pay off the outstanding
            loan amount over a 12-month repayment phase.
          </Trans>
        </p>
      </div>
    </div>
  );
};
